import { Box } from "@mui/material";
import React from "react";
import { Base } from "../../base";
import SearchParams from "../../../types/searchParams";
import KeyValue from "../../../types/keyValue";
import SitesFilterForm from "../../forms/SitesFilterForm";

interface Props {
  apiSiteTypeSearch: (search: SearchParams) => void;
  handleFiltering: (filterName: string, e?: KeyValue) => void;
  apiSiteSearch: (search: SearchParams) => Promise<void>;
  setFilter: (params: SearchParams) => void;
  phone: boolean;
}

const SitesFilter: React.FC<Props> = (props) => {
  const {
    apiSiteTypeSearch,
    handleFiltering,
    apiSiteSearch,
    setFilter,
    phone,
  } = props;

  return (
    <Box
      sx={{
        marginX: { sm: 5, xs: 3 },
        marginY: { sm: 2, xs: 0 },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Base.AccordionSwitch
        title="Filters"
        content={
          <SitesFilterForm
            apiSiteTypeSearch={apiSiteTypeSearch}
            handleFiltering={handleFiltering}
            apiSiteSearch={apiSiteSearch}
            setFilter={setFilter}
            phone={phone}
          />
        }
      />
    </Box>
  );
};

export default SitesFilter;
